var React = require('react');

function FooterNumber (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".1","fill":"#232323"},React.createElement("path",{"d":"M.355 93.12l12 12.15h43.05l12.15-12.15v-80.7L55.405.27h-43.05l-12 12.15v80.7zm15-79.35h37.05v10.95l-37.05 37.05v-48zm37.05 78h-37.05V80.82l37.05-37.05v48zM149.733 93.12v-37.2l-12.15-12.15h-40.05v-30h52.2V.27h-55.05l-12.15 12.15v32.7l12.15 12.15h40.05v34.5h-37.2v-16.5h-15v17.85l12.15 12.15h42.9l12.15-12.15z"})));
}

FooterNumber.defaultProps = {"width":"150","height":"106","fill":"none"};

module.exports = FooterNumber;

FooterNumber.default = FooterNumber;
